import { Button } from '@mui/material';
import { useErrorMessage } from '@shared/hooks/use-error-message';
import React, { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import InfoTooltip from '@shared/components/info-tooltip/info-tooltip';
import useDeviceStore from '../../store/devices.store';
import { AsignScreenFormProps } from '@modules/digital-signage/model/devices.model';
import {
  convertToSelectedAssignScreen,
  digitalSignageAddScreenErrorMessages
} from '@modules/digital-signage/utils/digital-signage.utils';
import AppAutocompleteV2 from '@components/app-autocomplete/app-autocomplete-v2.tsx';

const AddScreenDialogForm: React.FC<AsignScreenFormProps> = ({
  handleClose,
  tableStore,
  screensList,
  selectedItem
}) => {
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors, isValid }
  } = useForm({ mode: 'onTouched' });

  const getErrorMessage = useErrorMessage();

  const { t } = useTranslation();
  const { assignScreenDigitalSignageDevice, isLoading } = useDeviceStore();

  const handleSave = (data: any) => {
    const screenId = Array.isArray(data.assignScreen)
      ? data.assignScreen[0]?.id
      : data.assignScreen?.id;

    const sortedData = {
      id: selectedItem._id,
      screenId
    };

    assignScreenDigitalSignageDevice({
      data: sortedData,
      state: tableStore.getState(),
      handleClose
    });
  };

  const selectedAssignScreen = useMemo(() => {
    return convertToSelectedAssignScreen(selectedItem);
  }, [selectedItem]);

  useEffect(() => {
    if (selectedItem) {
      reset({
        assignScreen: selectedAssignScreen
      });
    }
  }, [selectedItem, reset]);

  return (
    <div>
      <form className="flex flex-col gap-1" onSubmit={handleSubmit(handleSave)}>
        <AppAutocompleteV2
          name="assignScreen"
          control={control}
          label={
            <span className="flex items-center">
              <span className="reuqired-symbole">*</span>
              {t('label_assign_screen')}
              <InfoTooltip text="tooltip_info_assign_screen" />
            </span>
          }
          selectedList={selectedAssignScreen}
          options={screensList}
          validationProps={{
            errors,
            errorMessages: digitalSignageAddScreenErrorMessages,
            getErrorMessage,
            validationRules: { required: true }
          }}
        />

        <div className="flex justify-end items-center gap-6">
          <Button
            type="submit"
            disabled={!isValid}
            variant="contained"
            loading={isLoading()}
          >
            {t('save')}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddScreenDialogForm;
